/**
 * Unified sort buttons component
 *
 * @param {Array} options - Array of { key, label } for sort options
 * @param {string} value - Currently selected sort key
 * @param {string} direction - "asc" or "desc"
 * @param {function} onChange - Called with (key, direction) when changed
 * @param {string} className - Additional classes
 */
const SortButtons = ({
  options,
  value,
  direction = "desc",
  onChange,
  className = "",
}) => {
  const handleClick = key => {
    if (value === key) {
      // Toggle direction
      onChange(key, direction === "asc" ? "desc" : "asc");
    } else {
      // New column, default to asc
      onChange(key, "asc");
    }
  };

  return (
    <div className={`flex items-center gap-2 text-xs text-base-content/50 ${className}`}>
      <span>Sort:</span>
      {options.map(({ key, label }) => (
        <button
          key={key}
          onClick={() => handleClick(key)}
          className={`px-1 py-0.5 ${
            value === key ? "text-primary font-medium" : "hover:text-base-content"
          }`}
        >
          {label}
          {value === key && (
            <span className="ml-0.5">{direction === "asc" ? "↑" : "↓"}</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default SortButtons;
